(function () {
  'use strict';
  function init() {
    var drawer = document.querySelector('[data-seerat-cart]');
    if (!drawer || drawer.dataset.seeratReady) return;
    drawer.dataset.seeratReady = 'true';
    var root = drawer.dataset.root || '/';
    if (root.slice(-1) !== '/') root += '/';
    var percent = Number(drawer.dataset.prepaidPercent) || 5;
    var currency = drawer.dataset.currency || 'INR';
    var version = 0, recommendationsVersion = 0, timer, lastKey = '';
    var area = drawer.querySelector('[data-seerat-suggestions]');
    var track = drawer.querySelector('[data-seerat-recommendations]');
    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:currency, maximumFractionDigits:2}).format(cents / 100);
    }
    function node(tag, cls, text) {
      var el = document.createElement(tag);
      if (cls) el.className = cls;
      if (text != null) el.textContent = text;
      return el;
    }
    function safeLink(value) {
      try { var url = new URL(value, location.origin); return url.origin === location.origin ? url.pathname + url.search : null; } catch (_) { return null; }
    }
    function render(products, cart, requestVersion) {
      if (requestVersion !== recommendationsVersion) return;
      var ids = new Set(cart.items.map(function (item) { return Number(item.product_id); }));
      track.replaceChildren();
      products.filter(function (p) { return !ids.has(Number(p.id)) && p.variants && p.variants.some(function (v) {return v.available;}); }).slice(0,6).forEach(function (product) {
        var href = safeLink(product.url || root + 'products/' + product.handle);
        if (!href) return;
        var card = node('article','seerat-rec');
        var link = node('a'); link.href = href;
        var image = node('img'); image.loading = 'lazy'; image.alt = product.title;
        var src = product.featured_image || (product.images && product.images[0]);
        src = typeof src === 'object' && src ? src.src : src;
        if (src && /^(https?:\/\/|\/\/|\/)/.test(src)) {image.src = src; link.append(image);}
        link.append(node('span','seerat-rec__title',product.title)); card.append(link);
        var price = node('span','seerat-rec__price',money(product.price)); card.append(price);
        var select = node('select'); select.setAttribute('aria-label','Choose option for ' + product.title);
        var placeholder = node('option',null,'Choose size / option'); placeholder.value = ''; select.append(placeholder);
        product.variants.filter(function (v) {return v.available;}).forEach(function (variant) {
          var option = node('option',null,variant.title === 'Default Title' ? 'Standard' : variant.title);
          option.value = String(variant.id); option.dataset.price = variant.price; select.append(option);
        });
        card.append(select);
        var button = node('button',null,'+ Add to Cart'); button.type = 'button'; button.disabled = true; card.append(button);
        var error = node('span','seerat-rec__error'); error.setAttribute('role','status'); card.append(error);
        select.addEventListener('change',function () {button.disabled = !select.value; error.textContent = ''; if (select.value) price.textContent = money(Number(select.selectedOptions[0].dataset.price));});
        button.addEventListener('click',async function () {
          if (!select.value || button.disabled) return;
          var selectedId = select.value; button.disabled = true; select.disabled = true; button.textContent = 'Adding…'; error.textContent = '';
          try {
            var response = await fetch(root + 'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(selectedId),quantity:1}]})});
            var data = await response.json();
            if (!response.ok) throw new Error(data.description || 'Unable to add this product.');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:data.items ? data.items[0] : data,addToCartBtn:button}}));
            document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); schedule();
            button.textContent = 'Added';
          } catch (err) {error.textContent = err.message || 'Please try again.'; button.textContent = '+ Add to Cart';}
          finally {select.disabled = false; button.disabled = !select.value;}
        });
        track.append(card);
      });
      area.hidden = !track.children.length;
    }
    async function recommend(cart) {
      var key = cart.items.map(function (i) {return i.product_id;}).sort().join(',');
      if (key === lastKey) return;
      lastKey = key;
      var requestVersion = ++recommendationsVersion;
      area.hidden = true;
      if (!cart.items.length) {track.replaceChildren(); return;}
      try {
        var response = await fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(cart.items[0].product_id) + '&limit=10&intent=related',{credentials:'same-origin'});
        if (!response.ok) throw new Error('Recommendations unavailable');
        var data = await response.json();
        var ids = new Set(cart.items.map(function (item) {return Number(item.product_id);}));
        var products = (data.products || []).filter(function (p) {return !ids.has(Number(p.id)) && p.variants && p.variants.some(function (v) {return v.available;});});
        if (!products.length) {
          var fallback = await fetch(root + 'collections/all/products.json?limit=16',{credentials:'same-origin'});
          if (!fallback.ok) throw new Error('Products unavailable');
          var fallbackData = await fallback.json();
          products = (fallbackData.products || []).map(function (p) {
            return Object.assign({},p,{price:Math.round(Number(p.variants[0].price)*100),variants:p.variants.map(function (v) {return Object.assign({},v,{price:Math.round(Number(v.price)*100)});})});
          });
        }
        render(products,cart,requestVersion);
      } catch (_) {if (requestVersion === recommendationsVersion) {lastKey = ''; area.hidden = true;}}
    }
    function apply(cart) {
      if (typeof cart.currency === 'string') currency = cart.currency;
      drawer.querySelector('[data-seerat-count]').textContent = cart.item_count;
      var eligible = cart.items.filter(function (item) {return !item.gift_card;}).reduce(function (sum,item) {return sum + Number(item.final_line_price || 0);},0);
      eligible = Math.min(eligible,Number(cart.total_price || 0));
      drawer.querySelector('[data-seerat-savings]').textContent = money(Math.floor(eligible * percent / 100));
      drawer.querySelector('[data-seerat-savings-row]').hidden = !eligible;
      var label = drawer.querySelector('.gokwik-checkout .btn-text > span:first-child');
      if (label) label.textContent = 'Proceed to Checkout';
      recommend(cart);
    }
    function schedule() {
      var requestVersion = ++version; clearTimeout(timer);
      timer = setTimeout(async function () {
        try {
          var response = await fetch(root + 'cart.js',{credentials:'same-origin',cache:'no-store'});
          if (!response.ok) return;
          var cart = await response.json();
          if (requestVersion === version) apply(cart);
        } catch (_) {}
      },50);
    }
    ['cart:updated','seerat:cart-updated','ajaxProduct:added','cart:refresh','cart:build','cart:open'].forEach(function (name) {document.addEventListener(name,schedule);});
    new MutationObserver(schedule).observe(drawer.querySelector('[data-products]'),{childList:true,subtree:true});
    new MutationObserver(schedule).observe(drawer,{attributes:true,attributeFilter:['class']});
    drawer.addEventListener('click',async function (event) {
      var link = event.target.closest('.cart__remove a');
      if (!link || !drawer.contains(link)) return;
      var item = link.closest('[data-key]'); if (!item) return;
      event.preventDefault(); if (link.dataset.pending) return; link.dataset.pending = 'true';
      try {
        var response = await fetch(root + 'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.dataset.key,quantity:0})});
        var cart = await response.json();
        if (!response.ok) throw new Error(cart.description || 'Unable to remove this item.');
        document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart}}));
        document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
      } catch (_) {delete link.dataset.pending; var error = item.querySelector('[data-seerat-remove-error]'); if (!error) {error = node('span',null,'Could not remove. Please try again.'); error.dataset.seeratRemoveError = 'true'; error.setAttribute('role','status'); item.append(error);}}
    });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();